<template>
  <div v-if="state.isVisible" @click.self="close" @keyup.esc="close" :id="processID"
       tabindex="-1" class="context-menu-mask v-modal">
    <div :style="style"
         ref="contextMenu"
         :class="classes"
         class="context-menu">
      <slot></slot>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue from "vue";
  import {StringHelper} from "~/helpers/stringHelper";
  import scrollToElement from "~/helpers/scrollToElement"

  export default Vue.extend({
    props: {
      state: Object,
      index: {
        default: '',
      },
      fixed: {
        type: Boolean,
        default: false
      },
      maxHeightFlexible: {
        type: Boolean,
        default: false
      },
      scroll: {
        type: Boolean,
        default: false
      },
      scrollTo: {
        default: null,
      },
      scrollOffset: {
        default: 0,
      },
    },

    data: function () {
      return {
        top: null,
        left: null,
        maxHeight: null,
        edgePadding: 50,
        targetParent: undefined,
        classes: [{'overflow-auto': scroll}],
        recalculate: true,
      }
    },

    mounted() {
      $(window).on('resize.contextMenu', e => {
        if (this.timeout) {
          clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.reposition, 300);
      });
    },

    updated() {
      this.reposition();
    },

    beforeDestroy() {
      $(window).off('resize.contextMenu');
    },

    methods: {
      close(event) {
        this.$emit('close', {event: event, id: this.state.id, isVisible: false});
      },

      open(event) {
        this.$nextTick(() => {
          let position = this.getPositionFromEvent(event);
          this.setPosition(position.top, position.left);
          this.focus();
        });
      },

      focus() {
        let input = $(this.$el).find(':input').not(".btn-icon").get(0);
        (input || this.$el).focus();
      },

      recalculatePosition(event) {
        return this.getPositionFromEvent(event);
      },

      setPosition(top, left) {
        let menu = this.$refs.contextMenu;
        let maxHeight = 0;
        let maxWidth = 0;
        let minimumHeight = 360;
        if (menu) {
          maxHeight =  window.innerHeight - minimumHeight - this.edgePadding;
          maxWidth = window.innerWidth - menu.offsetWidth - this.edgePadding;
        }

        if (this.maxHeightFlexible && this.targetParent !== undefined) {
          maxHeight = this.targetParent.offsetHeight
        }

        let calcTop = Math.max(Math.min(top, maxHeight), this.edgePadding);
        let calcLeft = Math.max(Math.min(left, maxWidth), this.edgePadding);
        if (!this.inViewport() && window.location.pathname.includes('certificates')) {
          calcTop = window.innerHeight - 360
          calcLeft = calcLeft/2
        }
        this.top = calcTop
        this.left = calcLeft
      },

      reposition(event?) {
        let newCoords = {top: this.top, left: this.left};
        if (event) {
          newCoords = this.recalculatePosition(event);
        }
        this.setPosition(newCoords.top, newCoords.left);
        if (this.recalculate) {
          if (!this.classes.includes('in-viewport') && this.inViewport() && window.location.pathname.includes('certificates')) {
            this.classes = [...this.classes, 'in-viewport']
          } else if (this.classes.includes('in-viewport') && !this.inViewport() && window.location.pathname.includes('certificates')) {
            this.classes = [{'overflow-auto': scroll}]
            this.recalculate = false
          }
        }
      },

      getPositionFromEvent(event): {top: number, left: number} {
        let eventTarget = event.target || event.relatedTarget;
        let position = {top: event.clientY, left: event.clientX};
        if (this.fixed || (!position.top && !position.left)) {
          let rect = eventTarget.getBoundingClientRect();
          position.top = rect.bottom;
          position.left = rect.left;
        }
        if (eventTarget && this.maxHeightFlexible && this.targetParent === undefined) {
          this.targetParent = eventTarget.closest('.scroll-area').children[0]
        }
        return position;
      },

      inViewport() {
        if (!this.$refs.contextMenu) return true
        return this.$refs.contextMenu.getBoundingClientRect().bottom < window.innerHeight
      }
    },
    computed: {
      style() {
        return this.state.isVisible ? {top: `${this.top}px`, left: `${this.left}px`, 'max-height': `${this.maxHeight}px`} : null;
      },
      processID() {
        let result = '';
        let hasIndex = this.index !== '';
        let hasIndexOnObject = this.vueModalID.hasOwnProperty(this.index, 10);

        if(hasIndexOnObject){
          result = 'modal-' + StringHelper.camelToDash(this.vueModalID[parseInt(this.index, 10)]);
        } else if(hasIndex) {
          result = 'modal-' + this.index;
        }
        return result;
      },
    },
    watch: {
      scrollTo(newVal, oldVal) {
        if (!newVal) return

        scrollToElement({
          $el: $(newVal),
          $container: $(this.$refs.contextMenu),
          relative: true,
          offset: this.scrollOffset,
        })
      }
    }
  });
</script>
